import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EffectsModule } from '@ngrx/effects';
import { FilesEffects } from './files-store/files.effects';
import { InternalSharedModule } from '../shared';
import {
  FileListDisplayComponent,
  AddFilesModalComponent,
  SelectFolderModalComponent,
  FileAssignComponentModalComponent,
} from './components';
import { FileLibraryComponent } from './pages';
import { services } from './shared/services';
import { filesRoutes } from './files.routing';
import { DxTooltipModule } from 'devextreme-angular';

const PROVIDERS = [
  ...services
];

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([FilesEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,
    ReactiveFormsModule,
    RouterModule.forChild(filesRoutes),
    SharedModule,
    DxTooltipModule
  ],
  providers: [
    PROVIDERS
  ],
  declarations: [
    /* Pages */
    FileLibraryComponent,

    /* Components */
    FileListDisplayComponent,
    AddFilesModalComponent,
    SelectFolderModalComponent,
    FileAssignComponentModalComponent,
  ],
  exports: [
  ]
})
export class FilesModule { }
